"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isReferredUser(object) {
    return checkReferredUser(object).fulfilled;
}
exports.isReferredUser = isReferredUser;
function checkReferredUser(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("userId")).withOptions(options).explain();
}
exports.checkReferredUser = checkReferredUser;
//# sourceMappingURL=ReferredUser.js.map